const DeviceDetailController = (
  $scope,
  $rootScope,
  $stateParams,
  $uibModal,
  installationsService,
  packagesService,
  equipmentRepository,
  TimezoneService,
  gettextCatalog,
  deviceDiagnosticService,
) => {
  'ngInject';

  $rootScope.selectedInstallationId = $stateParams.installationId;
  $scope.loading = true;
  $scope.editing = {};
  $scope.postingChange = false;
  $scope.selectedEquipment = {};
  $scope.userActions = '';
  $scope.moduleViewModel = '';
  $scope.hasPkgModules = false;
  $scope.canDeactivate = false;

  // private functions
  const getErrorMessage = (error = {}, defaultMsg = '') => {
    const {
      data: { message = '', Message = '' },
      status = '',
      statusText = '',
    } = error;
    return `${message || Message || defaultMsg} ${status}:${statusText} ${gettextCatalog.getString(
      '. Please try again later.',
    )} `;
  };

  const getDiagnosticSeries = (esn, assetId) => {
    $scope.gpsInfo = {};
    $scope.cellInfo = {};
    if (esn) {
      deviceDiagnosticService
        .getLastReportedCellSignalSeries(esn)
        .then((cellData) => {
          $scope.cellInfo = cellData;
        })
        .catch(() => {
          $scope.cellInfo = {
            status: 'Error',
          };
        });
    }
    if (assetId) {
      deviceDiagnosticService
        .getLastReportedGpsSeries(assetId)
        .then((gpsData) => {
          $scope.gpsInfo = gpsData;
        })
        .catch(() => {
          $scope.gpsInfo = {
            status: 'Error',
          };
        });
    }
  };

  $scope.deactivateButtonPressed = () =>
    $uibModal.open({
      animation: true,
      template: require('./deactivate-modal/deactivate.modal.html'),
      controller: 'DevicesDeactivateModalController',
      resolve: {
        installation: () => $scope.installation,
      },
      size: 'md',
    });

  // The user must have the feature permission to deactivate devices
  const canUserDeactivate = () =>
    !!$rootScope.currentUser.features.find((f) => f.path.indexOf('devices.deactivate') >= 0);

  $scope.canDeactivate = canUserDeactivate();

  // Local functions
  const refresh = () => {
    installationsService.getInstallationById($stateParams.installationId).then(
      (response) => {
        $scope.$emit('$viewContentLoaded');
        $scope.installation = response.data;

        const { equipment = {}, device = {} } = $scope.installation || {};
        getDiagnosticSeries(device.serialNumber, equipment.id);

        if ($scope.installation) {
          $scope.installation.basePkgs = [];
          $scope.installation.pkgModules = [];
          const pakageIds = ($scope.installation.packages || []).map((pkg) => pkg.id);
          if (pakageIds.length > 0) {
            packagesService.getPackageByIds(pakageIds).then(
              (packagesServiceResponse) => {
                const packages = packagesServiceResponse.data || [];

                $scope.installation.basePkgs = packages.filter((pkg) => !pkg.isModule);
                $scope.installation.pkgModules = packages.filter((pkg) => pkg.isModule);

                const m5device = ($scope.installation.device.attrs.model || '')
                  .toLowerCase()
                  .startsWith('m5s');

                const pkgWithSyncDatapoint = packages.find((pkg) => pkg.allowsRunHoursSync);
                if (pkgWithSyncDatapoint) {
                  $scope.installation.syncRunHourAvaliable =
                    pkgWithSyncDatapoint.allowsRunHoursSync && !m5device;
                  $scope.installation.syncRunHoursDataPoint = pkgWithSyncDatapoint.runHoursSync;
                }

                $scope.loading = false;
              },
              (error) => {
                $scope.loading = false;
                const errorMsg = getErrorMessage(
                  error,
                  gettextCatalog.getString('An error occurred while retrieving device information'),
                );
                $scope.onLoadErrorFlag = true;
                $scope.onLoadErrorText = errorMsg;
              },
            );
          } else {
            $scope.loading = false;
          }

          return equipmentRepository.getAllTags().then(
            (packagesServiceResponseResponse) => {
              // could this be done in $rootScope (like datapoints)?
              $scope.tags = packagesServiceResponseResponse.data.data;
              $scope.parseTags();
            },
            (error) => {
              const errorMsg = getErrorMessage(
                error,
                gettextCatalog.getString(
                  'An error occurred while retrieving attribute information',
                ),
              );
              $scope.errorFlag = true;
              $scope.errorText = errorMsg;
              $scope.assetLoading = false;
            },
          );
        }

        return null;
      },
      (error) => {
        $scope.loading = false;
        const errorMsg = getErrorMessage(
          error,
          gettextCatalog.getString('An error occurred while retrieving device information'),
        );

        $scope.onLoadErrorFlag = true;
        $scope.onLoadErrorText = errorMsg;
      },
    );
  };

  refresh(); // call when controller is initialized

  $scope.isBrowser = {
    IE10: false,
    IE9: false,
    EDGE: false,
  };
  $scope.showInstallationNotesModal = () => {
    $scope.animationsEnabled = true;
    // Adding a fix for EDGE 25.1 - autofocus miss places the cursor above the textarea when the modal loads
    // found a fix here http://stackoverflow.com/questions/25764824/strange-cursor-placement-in-modal-when-using-autofocus-in-internet-explorer
    // and here http://stackoverflow.com/questions/31757852/how-can-i-detect-internet-explorer-ie-and-microsoft-edge-using-javascript
    // Detect Microsoft Browser
    if (/MSIE 10/i.test(navigator.userAgent)) {
      // This is internet explorer 10
      $scope.isBrowser.IE10 = true;
    }
    if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
      // This is internet explorer 9 or 11
      $scope.isBrowser.IE9 = true;
    }
    if (/Edge\/\d./i.test(navigator.userAgent)) {
      // This is Microsoft Edge
      $scope.isBrowser.EDGE = true;
    }

    const modalInstance =
      $scope.isBrowser.IE10 || $scope.isBrowser.IE9 || $scope.isBrowser.EDGE
        ? $uibModal.open({
            animation: $scope.animationsEnabled,
            windowClass: 'modal fade in',
            template: require('./install-notes-modal/notes.modal.html'),
            controller: 'InstallationNotesModalController',
            size: 'md',
            resolve: {
              // optional, to pass any items to modal
              installation: () => $scope.installation,
              note: () => $scope.note,
            },
          })
        : $uibModal.open({
            animation: $scope.animationsEnabled,
            template: require('./install-notes-modal/notes.modal.html'),
            controller: 'InstallationNotesModalController',
            size: 'md',
            resolve: {
              // optional, to pass any items to modal
              installation: () => $scope.installation,
              note: () => $scope.note,
            },
          });

    // "Save As" modal dialog result - called when user clicks save
    modalInstance.result.then(
      (note) => {
        $scope.note = note;
      },
      () => {},
    );
  }; // end showSelectProductsModal()

  $scope.parseTags = () => {
    $scope.parsedTags = [];
    $scope.parsedAttrs = {};

    for (const key in $scope.installation.equipment.attrs) {
      let found = false;
      for (let j = 0; j < $scope.tags.length; j++) {
        if (key.toLowerCase() === $scope.tags[j].key.toLowerCase()) {
          $scope.parsedTags.push({
            key: $scope.tags[j].key,
            value:
              $scope.tags[j].dataType === 'Datetime'
                ? TimezoneService.tagToUserTimezone($scope.installation.equipment.attrs[key])
                : $scope.installation.equipment.attrs[key],
            index: j,
            datatype: $scope.tags[j].datatype,
            id: $scope.tags[j].id,
          });
          found = true;
          break;
        }
      }
      if (!found) {
        $scope.parsedAttrs[key] = $scope.installation.equipment.attrs[key];
      }
    }
  };
};

export default DeviceDetailController;
